@if (engagementSharedSites) {
  <article>
    <section>
      <table class="table">
        <thead>
          <tr>
            <th>Site</th>
            <th>Organisation</th>
          </tr>
        </thead>
        <tbody>
          @for (sharedSite of engagementSharedSites; track sharedSite) {
            <tr>
              <td>
                @if (user?.role === 'admin') {
                  <span class="site-id" title="Site id" tooltipPosition="top">{{ sharedSite.site.id }}</span>
                }
                {{ sharedSite.site.title }}
              </td>
              <td>
                @for (sharedOrg of sharedSite.orgs; track sharedOrg) {
                  <span class="org" title="{{ sharedOrg.count }}" [escape]="false" [class.has-routes]="sharedOrg.count" [title]="sharedOrg.count ? '<b style=\'color:yellow\'>Has user engagement</b>' : 'No user engagement'" tooltipPosition="top">
                    {{ sharedOrg.org.title }}
                  </span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  </article>
}
